import { connect } from 'react-redux';

import { clearFiltersAction } from '../../../../../domain/state/filters/actions';
import { FiltersClearButton } from '../../../../../../../components/Filters/components/FiltersClearButton';

const mapDispatchToProps = (dispatch) => ({
  onClick: () => dispatch(clearFiltersAction()),
});

const FiltersClear = connect(null, mapDispatchToProps)(FiltersClearButton);
export { FiltersClear };
